import { useEffect } from 'react';

export function useJsonLd(jsonLd?: object) {
  const jsonLdKey = jsonLd ? JSON.stringify(jsonLd) : '';

  useEffect(() => {
    if (!jsonLd) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-seo-jsonld', 'true');
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.querySelectorAll('script[data-seo-jsonld="true"]').forEach((el) => el.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonLdKey]);
}